export default __webpack_public_path__ + "static/underline-witb-339b8fbed42ba099ba2a455638b36644.svg";